import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, Button, Modal, message } from 'antd';

import {
  useFindParkingLaneByIdQuery,
  useCreateParkingLaneMutation,
  useUpdateParkingLaneMutation,
} from 'reducers/masterData/parkingLane/api';

import { goBack } from 'connected-react-router';
import { useErrorHandler } from 'common_components/ErrorContext';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';

const DiagramOwnerFormComponent = (props) => {
  const { id } = useParams();

  const { formData, isCreate } = props;
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { setErrorData } = useErrorHandler();

  // Query Parking Lane by ID
  const {
    data: dataParkingById,
    error: errorParkingById,
    isFetching: isParkingByIdFetching,
    refetch: refetchParkingById,
  } = useFindParkingLaneByIdQuery(id, {
    skip: !id,
  });
  useEffect(() => {
    if (dataParkingById) {
      form.setFieldsValue({ name: dataParkingById.name });
    }
  }, [dataParkingById]);

  useEffect(() => {
    if (errorParkingById) {
      Modal.confirm({
        title: 'Confirm',
        icon: <ExclamationCircleOutlined />,
        content: 'Failed to load parking lane',
        okText: 'Retry',
        onOk: refetchParkingById,
        cancelText: 'Cancel',
      });
    }
  }, [errorParkingById, refetchParkingById]);

  const [
    createParkingLane,
    {
      isSuccess: isSuccessCreating,
      isUninitialized: isUninitCreating,
      error: errorCreating,
      isLoading: isCreating,
    },
  ] = useCreateParkingLaneMutation();

  const [
    updateParkingLane,
    {
      isSuccess: isSuccessUpdating,
      isUninitialized: isUninitUpdating,
      error: errorUpdating,
      isLoading: isUpdating,
    },
  ] = useUpdateParkingLaneMutation();

  useEffect(() => {
    if (errorCreating) {
      setErrorData(errorCreating);
    }
    if (errorUpdating) {
      setErrorData(errorUpdating);
    }
  }, [errorUpdating, errorCreating, setErrorData]);

  useEffect(() => {
    if (
      (!isUninitUpdating && isSuccessUpdating) ||
      (!isUninitCreating && isSuccessCreating)
    ) {
      message.success('Data was successfully saved');
      if (isSuccessCreating) {
        dispatch(goBack());
      }
    }
  }, [
    isSuccessUpdating,
    isUninitUpdating,
    isSuccessCreating,
    isUninitCreating,
    dispatch,
  ]);

  const onClickSubmit = (values) => {
    Modal.confirm({
      title: 'Confirm',
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure want to submit?',
      okText: 'Confirm',
      cancelText: 'Cancel',
      onOk: handleConfirmAction,
    });
  };

  const handleConfirmAction = () => {
    let validData = form.getFieldsValue(true);

    let postData = {
      name: validData && validData.name,
      ...validData,
    };
    let putData = {
      name: validData && validData.name,
      ...validData,
      id: id,
    };

    if (isCreate) {
      createParkingLane(postData);
    } else {
      updateParkingLane(putData);
    }
  };

  return (
    <Form
      form={form}
      name="basic"
      labelCol={{
        span: 4,
      }}
      wrapperCol={{
        span: 14,
      }}
      style={{ padding: '20px' }}
      autoComplete="off"
    >
      <Form.Item
        wrapperCol={{
          offset: 16,
          span: 8,
        }}
      >
        <Button
          type="primary"
          htmlType="submit"
          loading={isCreating || isUpdating}
          onClick={onClickSubmit}
        >
          Submit
        </Button>
      </Form.Item>
      <Form.Item
        label="Name"
        name="name"
        rules={[
          {
            required: true,
            message: 'Please input parking lane name',
          },
        ]}
      >
        <Input placeholder={'Parking Lane name'} />
      </Form.Item>
    </Form>
  );
};

export default DiagramOwnerFormComponent;
